export const State0 = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="12" height="12" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.94271 2.38711C5.96857 2.34371 6.03144 2.34371 6.05731 2.38711L10.3224 9.54336C10.349 9.58779 10.3169 9.64422 10.2651 9.64422H1.73489C1.68313 9.64422 1.65109 9.58779 1.67759 9.54336L5.94271 2.38711ZM6.00001 4.16542C5.74508 4.16542 5.54121 4.37728 5.55101 4.63202L5.65366 7.30085C5.66081 7.48695 5.81376 7.63413 6.00001 7.63413C6.18625 7.63413 6.33919 7.48695 6.34635 7.30085L6.449 4.63202C6.4588 4.37728 6.25494 4.16542 6.00001 4.16542ZM5.99993 9.12792C6.27624 9.12792 6.50023 8.90392 6.50023 8.62762C6.50023 8.35133 6.27624 8.12732 5.99993 8.12732C5.72362 8.12732 5.49964 8.35133 5.49964 8.62762C5.49964 8.90392 5.72362 9.12792 5.99993 9.12792Z"
      fill="#CE2C31"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.63031 2.0456C6.34574 1.56813 5.65427 1.56813 5.3697 2.0456L1.10458 9.20183C0.813078 9.69091 1.1655 10.3113 1.73489 10.3113H10.2651C10.8345 10.3113 11.1869 9.69091 10.8954 9.20183L6.63031 2.0456ZM5.94271 2.38711C5.96857 2.34371 6.03144 2.34371 6.05731 2.38711L10.3224 9.54336C10.349 9.58779 10.3169 9.64422 10.2651 9.64422H1.73489C1.68313 9.64422 1.65109 9.58779 1.67759 9.54336L5.94271 2.38711Z"
      fill="#CE2C31"
    />
  </svg>
);
